// Import { IdentifierErrorType } from "@/containers/VerificationCode/use-identifier-error-alert";
import { SignInIdentifier } from '@logto/schemas';

// Import type { VerificationCodeIdentifier } from '@/types';
import { useTranslation } from 'react-i18next';

import BirdWelcome from '@/ui-assets/images/bird-cheer.webp';
import { formatPhoneNumberWithCountryCallingCode } from '@/utils/country-code';

import styles from './index.module.scss';

// Export function CreateAccountModalContent(errorType: IdentifierErrorType, method: VerificationCodeIdentifier, value: string) {
export const CreateAccountModalContent = (type: string, value: string) => {
  const { t } = useTranslation();

  return (
    <div>
      <img className={styles.image} src={BirdWelcome} width={225} height={146} alt="" />
      <p className={styles.title}>{t('description.sign_in_id_does_not_exist_title')}</p>
      <p className={styles.description}>
        {t('description.sign_in_id_does_not_exist', {
          type: t(`description.${type === SignInIdentifier.Email ? 'email' : 'phone_number'}`),
          value:
            type === SignInIdentifier.Phone
              ? formatPhoneNumberWithCountryCallingCode(value)
              : value,
        })}
      </p>
    </div>
  );
};
